<template>
    <div>
        <header-view />
        <router-view></router-view>
        <section class="contact" v-if="!hideContactSection"> 
            <contact />
        </section>
        <!-- <section class="subscribe">
            <subscribe />
        </section> -->
        <FooterArea class="footer" />
    </div>

</template>

<script>
import HeaderView from '../components/layout/HeaderView.vue'
import Contact from '../components/layout/ContactArea.vue';
// import Subscribe from '../components/layout/SubscribeHere.vue';
import FooterArea from '../components/layout/FooterArea.vue';
import { useSeo } from '@/composables/useseo'

export default {
    setup() {
        const host = window.location.hostname;
        let sub = host.split('.')[0];

        // Domaini kryesor te regjistrohet si "sistemi"
        if (host === 'prokuroria-rks.org' || host === 'www.prokuroria-rks.org') {
            sub = 'sistemi';
        }

        const titles = {
            sistemi: "Sistemi Prokurorial i Republikës së Kosovës",
            kpk: "Këshilli Prokurorial i Kosovës",
            sekretariati: "Sekretariati i Këshillit Prokurorial të Kosovës",
            zkpsh: "Zyra e Kryeprokurorit të Shtetit",
            pa: "Prokuroria e Apelit",
            ps: "Prokuroria Speciale e Republikës së Kosovës",
            pthprishtine: "Prokuroria Themelore në Prishtinë",
            pthprizren: "Prokuroria Themelore në Prizren",
            pthferizaj: "Prokuroria Themelore në Ferizaj",
            pthpeje: "Prokuroria Themelore në Pejë",
            pthmitrovice: "Prokuroria Themelore në Mitrovicë",
            pthgjilan: "Prokuroria Themelore në Gjilan",
            pthgjakove: "Prokuroria Themelore në Gjakovë",
        };

        const title = titles[sub] || "Sistemi Prokurorial i Republikës së Kosovës";

        useSeo({
            title,
            description: `${title} - publikime, njoftime, vendime, strukturë organizative, dokumente dhe transparencë institucionale.`
        });
        },

    data(){
        return{
            subdomain:''
        }
    },
    computed: {
        hideContactSection() {
            const path = this.$route.path
            const query = this.$route.query
            const host = window.location.hostname // merr subdomain-in aktual

            // kushtet
            const isDocuments51 = path === '/documents' && query.documentTypeId === '51'
            const isDisciplining = path === '/documents' && query.documentTypeId === '40'
            const proffesionalEthics = path === '/documents' && query.documentTypeId === '42'
            const publicRelattions = path === '/latestnews'
            const announcements = path === '/punesimi'
            const aboutKpk = path === '/about_kpk'

            const kryesuesi_kpk = path === '/prokuroret/76'
            const anetaret_kpk = path === '/prokuroret/85'
            const komisionet_kpk = path === '/komisionet_kpk'
            const gallery_kpk = path === '/gallery'
            const contact_kpk = path === '/kontakt/205'

            const zkpshaboutus = path === '/zkpshaboutus'
            const kryesuesi_zkpsh = path === '/prokuroret/100'
            const prokuroret_zkpsh = path === '/prokuroret/106'
            const koridnatoret_zkpsh = path === '/prokuroret/111'
            const zmnv_zkpsh = path === '/zmnvzkpsh'
            const njnp_zkpsh = path === '/njnp_zkpsh'
            const zra_zkpsh = path === '/zra_zkpsh'
            const zkp_zkpsh = path ==='/zkp_zkpsh'
            
            const aboutus_pa = path === '/about_pa'
            const aboutus_ps = path === '/aboutus_ps'

            const aboutus_pthprishtine = path === '/aboutus_pthprishtine'
            const aboutus_pthprizren = path === '/aboutus_pthprizren'
            const aboutus_pthferizaj = path === '/aboutus_pthferizaj'
            const aboutus_pthpeje = path === '/aboutus_pthpeje'
            const aboutus_pthmitrovice = path === '/aboutus_pthmitrovice'
            const aboutus_pthgjilan = path === '/aboutus_pthgjilan'
            const aboutus_pthgjakove = path === '/aboutus_pthgjakova'

            const isSekretariati = host.includes('sekretariati.')


            return isDocuments51 || isSekretariati || isDisciplining || proffesionalEthics || publicRelattions || announcements || aboutKpk || kryesuesi_kpk || anetaret_kpk || komisionet_kpk || gallery_kpk || contact_kpk || zkpshaboutus || kryesuesi_zkpsh || prokuroret_zkpsh || koridnatoret_zkpsh || zmnv_zkpsh || njnp_zkpsh || zra_zkpsh || zkp_zkpsh || aboutus_pa || aboutus_ps || aboutus_pthprishtine || aboutus_pthprizren || aboutus_pthferizaj || aboutus_pthpeje || aboutus_pthmitrovice || aboutus_pthgjilan || aboutus_pthgjakove
            }
        },
    components: {
        HeaderView,
        Contact,
        // Subscribe,
        FooterArea
    },
    methods:{
        getSubdomain() {
            const host = window.location.hostname; // p.sh. "kpk.localhost"
                this.subdomain = ''; // Default subdomain
                if (host.includes('.')) {
                    this.subdomain = host.split('.')[0];
                }
            },
        
    },
    mounted() {
        this.getSubdomain();
    },

    

};
</script>

<style scoped>

.title-report {
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    letter-spacing: -0.01em;
    color: #101828;
}

.report {
    background-color: #eff2f5;
    padding: 48px 0;
}

.contact {
    background-color: #eff2f5;
    margin-bottom: 0 !important;
}

.subscribe {
    background-color: #243652;
    padding: 48px 0;
    margin: 0;
}

.footer {
    background-color: #2c3f5e;
    color: white;
}
</style>